module.exports = __webpack_public_path__ + "img/1 手机.08476dbf.png";